/**
 * Visit — die Reichweitenzählung der Testphase.
 *
 * Betriebstechnik, kein Fach-Gegenstand des Portals: Gezählt wird EIN Besuch je
 * Person und Tag, nicht was jemand ansieht. Der Call steht trotzdem hier, weil
 * hier alle Call-Shapes stehen — App und Functions teilen genau einen Vertrag.
 *
 * WAS DER CLIENT SCHICKT, IST BEWUSST GROB. Jeder Wert für sich muss so
 * unscharf sein, dass ihn Millionen teilen; erst die Sammlung feiner Angaben
 * wäre ein Fingerabdruck. Adresse, Browser, System und Zeit kommen NICHT von
 * hier — die liest die Function aus dem Request, den sie ohnehin hat.
 */
/**
 * Name der Function — FESTER Name, eigene Definition in `functions/src/index.ts`.
 *
 * Bewusst NICHT über den Dispatcher `handleAppPut`: Dessen Handler verlangen
 * durchweg eine Anmeldung, ein Besuch ist aber anonym. Und im Log steht so eine
 * eigene Zeile statt eines weiteren Falls unter den Fach-Aufrufen.
 */
export const COUNT_VISIT_FUNCTION = "countVisit";
//# sourceMappingURL=visit-model.js.map